<template>
  <div
    class="mt-30 layer-main-wrapper">
    <div class="border-bottom pb-10">
      <span class="heading-layer-text fs-12 ms-13 text-semi-gray">Layers</span>
    </div>
    <draggable
      v-model="layerList"
      @sort="emitChangedList"
    >
      <div
        v-for="(layer,index) in layerList"
        v-if= "layer.type !== 'pagedetails'"
        :key="index"
        :id="layer.Id+'#layerId'"
        :class="[layer.isSelected ? 'active-layer' :'', layer.isEditableForRightPanel ? 'enable-grey-text':'',isDragged ? 'Drag-cursor':'reset-cursor' ]"
        class="d-flex align-items-center justify-content-between  py-7 px-16  layer-wrapper"
        @click.stop="selectLayer(layer)">
        <div class="layer-label-icon-wrapper d-flex align-items-center justify-content-between">
          <div class="d-flex flex-column align-items-center justify-content-center layer-icon me-4">
            <icon
              :name="getLayerType(layer)"
              class="custom-icon"/>
          </div>
          <div
            :class="[layer.isEditableForRightPanel ? 'expandable-input': '']"
            class="d-flex flex-column align-items-center justify-content-center layer-label ">
            <input
              v-model.trim="layer.Name"
              :readonly="!layer.isEditableForRightPanel"
              :class="[layer.isEditableForRightPanel ? 'border-blue-primary border-1 border btn-outline-0 ps-8 w-100 text-dark-gray selection-active':'border-0']"
              class="bg-none rounded rounded-4 ps-4 pe-8 py-4  fs-12  layer-input fs-12 text-dark-gray text-capitalize"
              ondblclick="this.setSelectionRange(0, this.value.length)"
              type="text"
              style="background: none; color: inherit; font: inherit;"
              @dblclick.stop="(layer.Name !=='z-border') && (layer.isEditableForRightPanel = true)"
              @blur.stop="layer.isEditableForRightPanel = false"
              @keyup.enter="layer.isEditableForRightPanel = false"
              @keydown="validateInput($event)"
            >
          </div>
        </div>
        <div
          :class="[layer.isEditableForRightPanel? 'd-none' : 'd-block']"
          class="d-flex align-items-center justify-content-center icons-hover-state">
          <div
            :class="[layer.IsVisible ? '':'active-state']"
            class="d-flex align-items-center justify-content-center m-1"
            @click.stop="toggleVisibility(layer)">
            <icon
              name="eye"
              class="eye-icon hover-icon"/>
            <icon
              name="hide-icon"
              class="hide-icon d-none"/>
          </div>
          <div
            class="d-flex align-items-center justify-content-center  m-1"
            @click.stop="duplicateLayer(layer)">
            <icon
              name="copied"
              class="hover-icon"/>
          </div>
          <div
            :class="[ layer.locked ? 'show-unlock-icon': 'show-lock-icon']"
            class="d-flex align-items-center justify-content-center m-1"
            @click.stop="lockLayer(layer)">
            <icon
              name= "locklayer"
              class="lock-icon d-none"/>
            <icon
              name = "unlock-icon"
              class="unlock-icon hover-icon"/>
          </div>
          <div
            class="d-flex align-items-center justify-content-center m-1"
            @click.stop="conformationMessagePopUp(layer,index)">
            <icon
              name="trash"
              class="hover-icon"
              stroke="#3BB0FA"
            />
          </div>
        </div>
      </div>
    </draggable>
    <draggable>
      <div
        v-for="(layer,index) in getProductAudio"
        :key="index"
        :class="[isAudioLayerSelected ? 'active-layer' :'', isAudioLayerEditableForRightPanel ? 'enable-grey-text':'']"
        class="d-flex align-items-center justify-content-between  py-7 px-16  layer-wrapper"
        @click.stop="selectAudioLayer(layer)">
        <div class="layer-label-icon-wrapper d-flex align-items-center justify-content-between">
          <div class="d-flex flex-column align-items-center justify-content-center layer-icon me-4">
            <icon
              name="audio"
              class="custom-icon"/>
          </div>
          <div
            :class="[layer.isEditableForRightPanel ? 'expandable-input': '']"
            class="d-flex flex-column align-items-center justify-content-center layer-label ">
            <input
              v-model.trim="layer.Name"
              :readonly="!isAudioLayerEditableForRightPanel"
              :class="[isAudioLayerEditableForRightPanel ? 'border-blue-primary border-1 border btn-outline-0 ps-8 w-100 text-dark-gray selection-active':'border-0']"
              class="bg-none rounded rounded-4 ps-4 pe-8 py-4  fs-12  layer-input fs-12 text-dark-gray text-capitalize"
              type="text"
              style="background: none; color: inherit; font: inherit;"
              @dblclick="makeAudioLayerEditableForRightPanel"
              @click.stop="selectAudioLayer"
              @blur.stop="updateAudioLayerName(layer.Name)"
              @keyup.enter="updateAudioLayerName(layer.Name)"
            >
          </div>
        </div>
        <div
          :class="[layer.isEditableForRightPanel? 'd-none' : 'd-block']"
          class="d-flex align-items-center justify-content-center icons-hover-state">
          <div
            class="d-flex align-items-center justify-content-center m-1"
            @click.stop="removeAudioFromProduct">
            <icon
              name="trash"
              class="hover-icon"
              stroke="#3BB0FA"
            />
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>
<script>
import { uuid } from 'vue-uuid';
import draggable from 'vuedraggable';
import _ from 'lodash';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  components: {
    draggable,
  },

  props: {
    product: {
      type: Object,
    },
    contentListReceive: Array,
    activePage:         Number,
  },

  data() {
    return {
      layerList:                         [],
      isDragged:                         false,
      isAudioLayerSelected:              false,
      isAudioLayerEditableForRightPanel: false,
    };
  },
  computed: {
    getProductAudio() {
      if (this.product && this.product.audioDetails && this.product.audioDetails.audioUrl) {
        const audioLayer = [{
          Name: this.product.audioDetails.Name,
        }];
        return audioLayer;
      }
      return 0;
    },
    getActivePageIndex() {
      return this.activePage;
    },
  },
  watch: {
    // TODO : remove watcher
    contentListReceive: {
      immediate: true,
      handler(newValue) {
        this.layerList = newValue;
      },
    },
  },
  mounted() {
    EventBus.$on('selectAudioLayerFromLeftSection', this.selectAudioLayerFromLeftSection);
    EventBus.$on('unSelectAudioLayer', this.unSelectAudioLayer);
    // EventBus.$on('deleteContentReq', this.deleteLayer);
    // EventBus.$on(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DUPLICATE, this.duplicateLayer);
  },
  destroyed() {
    EventBus.$off('selectAudioLayerFromLeftSection', this.selectAudioLayerFromLeftSection);
    EventBus.$off('unSelectAudioLayer', this.unSelectAudioLayer);
    // EventBus.$off('deleteContentReq', this.deleteLayer);
    // EventBus.$off(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DUPLICATE, this.duplicateLayer);
  },
  methods: {
    updateAudioLayerName(name) {
      this.isAudioLayerEditableForRightPanel = false;
      this.product.audioDetails.Name         = name;
    },
    selectAudioLayerFromLeftSection(value) {
      this.isAudioLayerSelected = value;
    },
    unSelectAudioLayer() {
      this.isAudioLayerEditableForRightPanel = false;
      this.isAudioLayerSelected              = false;
      EventBus.$emit('toggleAudioLeftSectionAccordion', false);
      this.$store.commit('activeProduct/UpdateIsAudioTrimOn', false);
    },
    makeAudioLayerEditableForRightPanel() {
      this.isAudioLayerEditableForRightPanel = true;
    },
    selectAudioLayer() {
      if (!this.isAudioLayerSelected) {
        EventBus.$emit('onObjectSelectedCleared');
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
        setTimeout(() => {
          this.isAudioLayerSelected = true;
          EventBus.$emit('toggleAudioLeftSectionAccordion', true);
        }, 10);
      }
    },
    removeAudioFromProduct() {
      EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, { request: 'RemoveAudioFromProduct', message: 'Are you sure you want to delete this?' });
    },
    getLayerType(layer) {
      let type = layer.type;
      if (type === 'image') {
        (layer.ImageType === 'WhiteboxLogo' || layer.ImageType === 'IndependentWhitebox') && (type = 'address');
        (layer.ImageType === 'FDICText' || layer.ImageType === 'FDICTextWhite') && (type = 'fdic');
        (layer.ImageType === 'FDICLogo' || layer.ImageType === 'FDICLogoWhite') && (type = 'equal-housing');
      }
      return type;
    },
    emitChangedList() {
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.layerList);
      EventBus.$emit(ApplicationEventTypes.Canvas.CANVAS_RE_RENDER);
      this.emitUndoRedoRequest('called by swap layer');
    },
    emitUndoRedoRequest(data) {
      EventBus.$emit('addIntoPageWiseUndoRedoArray', data);
    },
    selectLayer(layer) {
      Boolean(layer.IsVisible) && !layer.locked && EventBus.$emit('onObjectSelectedFromRightPanel', layer.Id);
      this.unSelectAudioLayer();
    },

    lockLayer(layer) {
      layer.locked = !layer.locked;
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      this.emitUndoRedoRequest('called by lock layer');
    },
    toggleVisibility(layer) {
      EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
      layer.IsVisible = !layer.IsVisible;
      this.emitUndoRedoRequest('called by toggleVisibility');
    },
    duplicateLayer(object) {
      const tempobj    = object;
      const clone      = _.cloneDeep(tempobj);
      clone.Id         = uuid.v1();
      clone.X         += 30;
      clone.Y         += 30;
      clone.isSelected = false;
      clone.editor     = null;
      clone.Name       = clone.PageNo === this.getActivePageIndex ? clone.Name += ' copy' : clone.Name;
      clone.PageNo     = this.activePage;
      clone.type == 'text' && clone.modifiedHtml !== clone.Value && (clone.Value = clone.modifiedHtml);
      this.layerList.unshift(clone);
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.layerList);
      this.emitUndoRedoRequest('called by duplicateLayer');
    },
    conformationMessagePopUp(layer, index) {
      !layer.locked && EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, { request: 'DeleteReq', data: index, message: 'Are you sure you want to delete this?' });
    },

    validateInput(evt) {
      if (!evt.target.readOnly) { evt.stopPropagation(); }
      const code = (evt.which) ? evt.which : evt.keyCode;
      // return if arrow keys, backspace or delete key
      if ([8, 37, 38, 39, 40, 46].indexOf(code) > -1) { return true; }
      if ((code >= 65 && code <= 90) || (code >= 48 && code <= 57 && !evt.shiftKey) || (code >= 96 && code <= 105 && !evt.shiftKey) || code == 109 || code == 32 || code == 189) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    modifyDragItem(dataTransfer) {
      const cursor = new Image();
      cursor.src   = '../../assets/images/drag-icon.jpg';
      dataTransfer.setDragImage(cursor, 10, 10);
    },
    resetIcon() {
    },
  },

};

</script>
<style  lang="scss">
  .layer-main-wrapper {

    .layer-text{
      font-weight: 600;
    }
    .heading-layer-text{
      font-weight: 600;
    }
  }
  .layer-wrapper {
    cursor: pointer;
    height: 36px;
    .icons-hover-state {
      opacity: 0;
    }
    &:hover {
      .icons-hover-state{
        opacity: 1;
      }
      background: $grey10;
      box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
    }

    .show-unlock-icon {
      .unlock-icon{
        display: none !important;
          svg{
            filter: invert(56%) sepia(30%) saturate(1577%) hue-rotate(176deg) brightness(105%) contrast(96%);
          }
        }
      .lock-icon{
        display: block !important;
        filter: invert(56%) sepia(30%) saturate(1577%) hue-rotate(176deg) brightness(105%) contrast(96%);
      }
    }

    .active-state{
      .eye-icon{
        display: none !important;
      }
      .hide-icon
      {
        svg{
          filter: invert(56%) sepia(30%) saturate(1577%) hue-rotate(176deg) brightness(105%) contrast(96%);}
        display: block !important;
      }

    }
  }
  .active-layer {
      &:hover{
        background-color: $blue10;
        box-shadow: none;
      }
      .icons-hover-state{
        opacity: 1;
      }
      background-color: $blue10;
      .layer-label-icon-wrapper {
        .layer-icon {
          .icon {
            svg {
              path {
                stroke: $blue50;
              }
            }
          }
        }
      }
          .layer-input {
            color: $blue50 !important;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: 124px;

          }
      }

   .text-capitalize input:hover {
       cursor: pointer;

   }
  .layer-input{
    height: 28px;
    width: 124px;
    font-weight: 600 !important;
    cursor: inherit;
    margin-left: -4px;
   }


   .expandable-input{
     width: calc(256px - 52px);
   }

  .enable-grey-text{
   .layer-input {
     color: $grey80 !important
   }
  }

  .Drag-cursor{
    cursor: url('../../assets/images/drag-icon.jpg') , auto !important;
  }


  .selection-active{
      margin-left: 0px;
    }

  .layer-main-wrapper input{
    text-overflow: ellipsis;
    white-space: nowrap;
  }


</style>
